export const GET_INVITES = 'getInvites';
export const DELETE_INVITE = 'deleteInvite';
export const DELETE_USER = 'deleteUser';
export const INVITE_USER = 'inviteUser';